import { detect } from 'detect-browser';
import _ from 'lodash';
const mobileVideoBreakpoint = 425;
const browser = detect();
/**
 * Updates the video sources to desktop on resize.
 * Doesn't do it the other way around since the mobile videoshould be a cropped version of the desktop video.
 */
function replaceMobileVideoSrc() {
    const isMobile = window.innerWidth <= mobileVideoBreakpoint;
    if (!isMobile) {
        const videoEls = document.querySelectorAll('video[data-lazy-loaded]:not([data-src-desktop-is-set])');
        videoEls.forEach(videoEl => {
            const sourceEls = videoEl.querySelectorAll('source[data-src-mobile][data-src-desktop]');
            if (sourceEls.length > 0) {
                sourceEls.forEach(sourceEl => {
                    sourceEl.src = sourceEl.dataset.srcDesktop ?? '';
                });
            }
            videoEl.dataset.srcDesktopIsSet = 'true';
            videoEl.load();
        });
    }
}
window.addEventListener('resize', _.throttle(replaceMobileVideoSrc, 500));
/**
 * Sets the data-src Attribute on each video source element when needed.
 */
export function replaceVideoSrcs(videoEl) {
    if (!videoEl.hasAttribute('data-lazy-loaded')) {
        const isMobile = window.innerWidth <= mobileVideoBreakpoint;
        videoEl.dataset.lazyLoaded = 'true';
        videoEl.querySelectorAll('source').forEach(sourceEl => {
            if (isMobile && sourceEl.hasAttribute('data-src-mobile')) {
                sourceEl.src = sourceEl.dataset.srcMobile ?? '';
            }
            else {
                sourceEl.src = sourceEl.dataset.srcDesktop ?? '';
                videoEl.dataset.srcDesktopIsSet = 'true';
            }
            if (sourceEl.src) {
                videoEl.load();
            }
        });
    }
    // Remove the custom poster element that sits on top of the video
    // This is needed because iOS safari has problems displaying it
    if (videoEl.hasAttribute('data-poster-el')) {
        const removePoster = function removePosterFunc() {
            // We need to make sure that the video actually started playing
            // The "playing" event is not sufficent enough
            const isSafari = browser && ((browser.name === 'ios' && browser.os === 'iOS') || browser.name === 'safari');
            if (!isSafari || videoEl.currentTime > 0.05) {
                videoEl.removeEventListener('timeupdate', removePoster);
                const posterImg = videoEl.parentNode?.querySelector(`img[data-poster-el="${videoEl.dataset.posterEl}"]`);
                videoEl.removeAttribute('data-poster-el');
                if (posterImg) {
                    posterImg.classList.add('is-hidden');
                }
            }
        };
        videoEl.addEventListener('timeupdate', removePoster);
    }
}
/**
 * A helper function to check if the video is playing.
 * This one is needed to prevent interuptions of play/pause to throw errors.
 */
export function videoIsPlaying(videoEl) {
    return videoEl.currentTime > 0 && !videoEl.paused && !videoEl.ended && videoEl.readyState > videoEl.HAVE_CURRENT_DATA;
}
